// Mirrors the backend AgentImageUploader allowlist and size_range.
export const PHOTO_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "gif"];
export const PHOTO_ACCEPT = "image/jpeg,image/png,image/webp,image/gif";
export const PHOTO_MAX_BYTES = 10 * 1024 * 1024;

export const validatePhoto = (
  file: File,
): "wrongFormat" | "tooLarge" | null => {
  const extension = file.name.split(".").pop()?.toLowerCase() ?? "";
  if (!PHOTO_EXTENSIONS.includes(extension)) return "wrongFormat";
  if (file.size > PHOTO_MAX_BYTES) return "tooLarge";
  return null;
};
